import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchDiscounts, clearDiscountsErrors  } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import DialogModal from '../home/DialogModal';

const propTypes = {
  dispatch: PropTypes.func,
  discounts: PropTypes.object,
  discountDisable: PropTypes.bool,
  onDiscountDisable: PropTypes.func,
};


class ShowDiscounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleteId: '',
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.discountDelete && (this.state.delete || nextProps.discounts.delete)) {
      const discounts = nextProps.discounts;
      discounts.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Discount deleted!',
        discounts,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleDisable(d) {
    const data = d;
    data.disabled = !d.disabled;
    data.discountLimitQty = (data.discountLimitQty === null) ? 0 : data.discountLimitQty;
    this.props.onDiscountDisable(data);
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: '',
    });
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearDiscountsErrors());
    this.props.dispatch(fetchDiscounts({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.discounts.results.map((discount, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{discount.name}</TableRowColumn>
        <TableRowColumn key={i}>{discount.discountType}</TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onDisable={() => this.handleDisable(discount)}
            onEdit={`/discounts/${discount.id}`}
            onView={`/discounts/${discount.id}`}
            disabled={discount.disabled}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Discount"
          dialogMessage="Do you really want to delete this discount?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Type</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowDiscounts.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowDiscounts.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.discounts.error,
    discountDisable: state.discounts.discountDisable,
    discounts: state.discounts,
  };
}

export default connect(mapStateToProps)(ShowDiscounts);



// WEBPACK FOOTER //
// ./src/components/discounts/ShowDiscounts.js